import sentry from 'legacy/utils/sentry'

import { createRfpGuideHttpClient } from '../infra/createRfpGuideHttpClient'
import { ProposalRepository } from '../infra/ProposalRepository'

export type WithdrawProposalFactoryDependencies = {
  proposalRepository: ProposalRepository
}

export function withdrawProposalFactory({
  proposalRepository,
}: WithdrawProposalFactoryDependencies) {
  return async function withdraw(id: string, config?: { signal: AbortSignal }) {
    try {
      return await proposalRepository.withdrawProposal(id, config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not withdraw the proposal', { cause: error as Error })
    }
  }
}

export async function withdrawProposal(id: string, config?: { signal: AbortSignal }) {
  const httpClient = createRfpGuideHttpClient()
  const proposalRepository = new ProposalRepository({ httpClient })
  const withdraw = withdrawProposalFactory({ proposalRepository })

  return withdraw(id, config)
}
